<template>
  <div v-if="isLoaded" style="height: 100%">
    <div class="columns weather">
      <div class="column is-12">
        <installation-weather
          :installation="installation"
        ></installation-weather>
      </div>
    </div>

    <div class="zones" v-bind:style="{ backgroundImage: 'url(' + image + ')' }">
      <div class="columns">
        <div class="column is-4">
          <h2 class="subtitle">{{ $t("installation.welcome") }}</h2>
          <h1 class="title">{{ installation.name }}</h1>
        </div>

        <div class="column is-8" style="text-align: right">
          <a @click="setInstallationPower" class="roundButton">
            <img
              v-if="installation.power"
              src="/home/images/buttons/btn_apagar_instalacion.png"
            />
            <img
              v-else
              src="/home/images/buttons/btn_apagar_instalacion_off.png"
            />
          </a>
          <a
            @click="
              $router.push('/installations/' + installation['.key'] + '/edit')
            "
            class="roundButton"
          >
            <img
              v-if="installation.power"
              src="/home/images/buttons/icn_editar_estancia.png"
            />
          </a>
          <a
            @click="
              $router.push('/installations/' + installation['.key'] + '/temp')
            "
            class="roundButton"
          >
            <img
              v-if="installation.power"
              src="/home/images/buttons/icn_temperatura.png"
            />
          </a>
          <a @click="goToQuickSense" class="roundButton">
            <img src="/home/images/buttons/btn_statistics.png" />
          </a>
          <a
            @click="
              $router.push('/installations/' + installation['.key'] + '/tariff')
            "
            class="roundButton"
          >
            <img src="/home/images/buttons/btn_tarifa.png" />
          </a>
        </div>
      </div>

      <br /><br />

      <div class="columns is-multiline">
        <div
          v-for="zone in orderedZones"
          :key="zone.id"
          class="column zone is-2-fullhd is-2-desktop is-12-tablet is-12-mobile"
          @click="loadZone(zone)"
        >
          {{ zone.name }}
          <br /><br />
          <div v-if="zone.final">
            <span v-if="!zone.power" class="zone-temp-off">Off</span>
            <p
              v-else-if="zone.mode === 'auto'"
              class="zone-temp"
              :class="getZoneTemperatureColor(zone)"
            >
              <small>AUTO</small>
            </p>
            <p
              v-else-if="zone.power"
              class="zone-temp"
              v-bind:class="getZoneTemperatureColor(zone)"
            >
              {{ Math.floor(zone.temp) }}
              <span class="scale-decimal"
                >º
                <span v-if="!isInt(zone.temp)" class="decimal">.5</span>
              </span>
            </p>
          </div>

          <div v-else>
            <img
              class="parent-zone"
              :src="
                zone.power
                  ? '/home/images/zones/zone-parent-on.png'
                  : '/home/images/zones/zone-parent-off.png'
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import firebase from "firebase/app";
import InstallationWeather from "../../../components/installations/InstallationWeather";
import InstallationThermostat from "../../../components/installations/InstallationThermostat";
import colors from "@/mixins/colors";
import zapp from "@/util/zapp";
import constants from "@/config/constants";

export default {
  components: {
    InstallationThermostat,
    InstallationWeather,
  },
  mixins: [colors],
  name: "installation-detail",
  props: {
    id: String,
  },
  data() {
    return {
      constants: constants,
      isLoaded: false,
      image: null,
    };
  },
  computed: {
    zones: function () {
      return this.installation.zones !== undefined
        ? Object.values(this.installation.zones).filter((zone) => {
            if (zone.type !== constants.zoneTypes.unknown) {
              return zone;
            }
          })
        : [];
    },

    ...mapState("installations", {
      installation: "current",
      tariff: "currentTariff",
    }),

    ...mapState("user", {
      user: "current",
    }),

    orderedZones: function () {
      return [...this.zones].sort((a, b) => a.name.localeCompare(b.name));
    },
  },

  methods: {
    setInstallationPower: function () {
      this.setPower({
        installation: this.installation,
        power: !this.installation.power,
      });
    },

    ...mapActions("installations", [
      "setCurrent",
      "setCurrentDevices",
      "setPower",
    ]),
    loadZone: function (zone) {
      this.$router.push(
        "/installations/" +
          this.installation[".key"] +
          "/zone/" +
          zone.path.split("/")[zone.path.split("/").length - 1]
      );
    },
    isInt: (n) => zapp.isInt(n),

    goToQuickSense() {
      let hasTariff = this.tariff.filter((hour) => hour > 0).length > 0;
      if (!hasTariff) {
        this.$dialog.alert(this.$t("statistics.noTariff"));
        return false;
      }

      if (!this.installation.zones) {
        this.$dialog.alert(this.$t("statistics.noDevices"));
        return false;
      }

      let devices = [];

      function getDevices(zone) {
        if (
          zone.zones === undefined &&
          zone.final &&
          zone.devices !== undefined
        ) {
          //ADD DEVICES
          Object.keys(zone.devices).forEach((device) => {
            devices.push(device);
          });
        }
        if (zone.zones !== undefined)
          Object.values(zone.zones).forEach((z) => getDevices(z));
      }

      Object.values(this.installation.zones).forEach((zone) => {
        getDevices(zone);
      });

      if (devices.length === 0) {
        this.$dialog.alert(this.$t("statistics.noDevices"));
        return false;
      }

      this.$router.push(
        "/installations/" + this.installation[".key"] + "/quicksense"
      );
    },
  },

  mounted() {
    this.setCurrent(this.id)
      .then(() => {
        this.isLoaded = true;
        //IMAGE
        if (this.installation.image_path !== undefined) {
          firebase
            .storage()
            .ref(this.user.uid)
            .child("installation-images")
            .child(this.installation.image_path)
            .getDownloadURL()
            .then((url) => {
              this.image = url;
            })
            .catch((error) => {
              console.log(error);
              this.image = "/home/images/backgrounds/installation.jpg";
            });
        } else {
          this.image = "/home/images/backgrounds/installation.jpg";
        }
      })
      .catch(() => {
        this.$router.push("/installations");
      });
  },
};
</script>

<style lang="scss" scoped>
.roundButton img {
  height: 5.5rem;
}

.weather {
  margin: 0 !important;
  height: 17.3vh;
}

.zones {
  .button-rounded {
    height: 4em;
    width: 4em;
    border-radius: 50%;
  }

  .columns {
    max-width: 100%;
  }

  .addZone {
    height: 5em;
    width: 5em;
    background-color: rgba(246, 244, 244, 0.91);
    margin-left: 2em;
    border: 1px solid transparent;

    .icon i::before {
      font-size: 2em;
    }
  }

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 4em;
  min-height: 80vh;

  .subtitle {
    font-size: 2em;
    text-align: left;
    color: white;
  }

  .title {
    font-size: 2.2em;
    text-align: left;
    color: white;
  }

  .zone {
    text-align: left;
    padding: 1em;
    border-radius: 0.8em;
    background-color: rgba(246, 244, 244, 0.91);
    margin-bottom: 1.3em;
    margin-right: 1.3em;
    font-size: 1.2em;
    cursor: pointer;
    width: calc(16.66667% - 1.3em);

    .zone-temp-off {
      font-size: 3rem;
    }

    .zone-temp {
      font-size: 3rem;
      margin-top: 0.5rem;
      line-height: 3.5rem;
    }

    .zone-temp .decimal {
      position: absolute;
      font-size: 1.6rem;
      left: -0.3em;
      top: 0.5rem;
    }

    .zone-temp .scale-decimal {
      position: relative;
      font-size: 2.2rem;
      margin-left: -0.5rem;
      top: -0.7rem;
    }
  }

  .parent-zone {
    display: block;
    margin: 0 auto;
  }
}

@include respondTo(mobile) {
  .roundButton img {
    height: 4rem;
  }

  .weather {
    height: 20%;
  }

  .zones {
    min-height: 80%;

    .zone {
      width: 100%;
    }
  }
}

@include respondTo(tablet) {
  .weather {
    height: 20%;
  }

  .zones {
    min-height: 80%;

    .zone {
      width: 100%;
    }
  }
}

@media only screen and (min-width: 1024px) and (max-width: 1380px) {
  .zones .zone {
    width: calc(33.333% - 1.3em);
  }
}
</style>
